// extracted by mini-css-extract-plugin
export default {"wrapper":"cp-z","response":"dp-z","error":"ep-z","disabled":"fp-z","buttons":"gp-z","feedbackQuestionSection":"hp-z","yesNoWrapper":"ip-z"};